/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ContactView from "../views/ContactView.vue";
import PrivacyView from "../views/PrivacyView.vue";
import NotFound from "@/views/ViewPage404.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
  {
    path: "/privacy-policy",
    name: "privacy",
    component: PrivacyView,
  },
  {
    path: "/404",
    name: "NotFoundError",
    component: NotFound,
  },
  {
    path: "/:catchAll(.*)", // Unrecognized path automatically matches 404
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(to, from, savedPosition) {
    let Position = Object;
    return new Promise((resolve, reject) => {
      if (savedPosition) {
        Position = savedPosition;
      } else {
        Position = { left: 0, top: 0 };
      }
      setTimeout(() => {
        resolve(Position);
      }, 500);
    });
  },
});

export default router;
